import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'friendlyDescription'})
export class FriendlyDescriptionPipe implements PipeTransform {
    transform(value: { [error: string]: any }, key: string): string {
        if (!value) {
            return '';
        }

        const err = Object.keys(value).pop();

        let isOrAre = 'is';
        if (key.endsWith('s') && key != 'Address' && key != 'clientCostType' && key != 'Status') {
            isOrAre = 'are';
        }

        switch (err) {
            case 'email':
                return ' should be a valid email address';
            case 'required':
            case 'requiredTrue':
                return ` ${ isOrAre } required`;
            case 'saved':
                return ` ${ isOrAre } not saved`;
            case 'invalid-format':
                return ' format is invalid';
            case 'file-empty':
                return ' file size is zero, please check the file and upload it again';
            case 'atLeastOneRequired':
                return ' at least one is required';
            case 'stringAlreadyExists':
                return ' is already in use';
            case 'dateBefore':
                return ` should be before end date`;
            case 'dateAfter':
                return ` should be before start date`;
            case 'min':
                return ` should be above the minimum: ${value.min?.min}`;
            case 'max':
                return ` should be below the maximum: ${value.max?.max}`;
            case 'minlength':
                return ` is too short, should be at least ${value.minlength?.requiredLength} characters`;
            case 'maxlength':
                return ` is too long (our limit is ${value.maxlength?.requiredLength} characters)`;
            case 'patternWithMessage':
                return value.patternWithMessage;
            case 'alwaysInvalid':
                return value.alwaysInvalid;
            case 'options':
                return value.options || ' does not have a valid option selected.';
            case 'dropdownOptions':
                return value.dropdownOptions || ' does not have a valid option selected.';
            case 'timeRequired':
                return `need a time to be set. Format needs to be HH:mm`;
            case 'invalidViewingTime':
                return ` date-time combination doesn't meet the criteria.` ;
            case 'invalidViewingDay':
                return ` this date is not available as a viewing day.` ;
            case 'timeInPast':
                return ` need a time in the future.` ;
            case 'invalidEmailList':
                return ` should be a valid email address or a list of valid email addresses separated by a comma. Eg. "john@doe.com, jane@doe.com"`;
            case 'emailFromOrgUser':
                return ` cannot be the email address of one of the organisation members.`;
            case 'invalidFormat':
                return ` format is invalid.`;
            case 'holdingFeeTooHigh':
                return ` should not exceed one week's rent`;
            case 'filesSumTooHigh':
                return `${value.filesSumTooHigh}`;
            case 'differentPaymentFrequencies':
                return ` - Different Payment Frequencies detected`
            case 'differentDepositTypes':
                return ` - Different Deposit Types detected`
            case 'differentRentTaxPercentage':
                return ` - Different Rent Tax detected`
            case 'differentBillsInclusive':
                return ` - Different Bills Types detected`
            case 'summedRentNotMatchingValue':
                return ` - Rents sum does not match value for Tenancy Agreement rent`
            case 'summedDepositNotMatchingValue':
                return ` - Deposits sum does not match value for Tenancy Agreement deposit`
            case 'differentStartDates':
                return ` - Tenancies have different move-in dates`
            case 'differentEndDates':
                return ` - Tenancies have different move-out dates`
            case 'viewingDateTooSoon':
                return ` - Date is too soon, should be at least ${value.viewingDateTooSoon?.minDaysBefore} days in advance.`
            case 'viewingDateTooFar':
                return ` - Date is too far, should be at most ${value.viewingDateTooFar?.maxDaysInAdvance} days in advance.`
            case 'tds-repayment-deduction-not-matching':
                return ` - TDS repayment amount summed to the deductions do not match to the deposit protected amount`
        }
    }
}
